import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'RedirectToMobile',
  setup(__props) {

const redirected = ref(false);
const route = useRoute();

const redirectToApp = () => {
  const appStoreLink =
    'https://apps.apple.com/br/app/warren-investimentos/id1114394063';
  const playStoreLink = route.query?.advisor
    ? `https://play.google.com/store/apps/details?id=com.oiwarren.oiwarren&referrer=utm_source${encodeURIComponent(
        `=${route.query?.advisor}`
      )}`
    : 'https://play.google.com/store/apps/details?id=com.oiwarren.oiwarren';

  if (!document.hidden) {
    if (
      navigator.userAgent.includes('iPhone') ||
      navigator.userAgent.includes('iPad')
    ) {
      window.location = appStoreLink as unknown as Location;
    } else {
      window.location = playStoreLink as unknown as Location;
    }
  }
  redirected.value = true;
};

onMounted(redirectToApp);

return { __sfc: true,redirected, route, redirectToApp }
}

})